import type { FC, ReactNode } from 'react';

import type { CommentMentionMetadata } from '@/types';

import CommentMentionTag from '../CommentMentionTag';

interface CommentMessageProps {
    message: string;
    metadata?: Record<string, unknown>;
    popupZIndex?: number;
}

const mentionMarkerPattern =
    /@\[([^\]]*)\]\(mention:((?:member|team):[a-zA-Z0-9_-]+|resource:[a-zA-Z]+:[a-zA-Z0-9_-]+)\)/g;

const mentionTargets = (metadata?: Record<string, unknown>) => {
    const commentMentions = metadata?.commentMentions as CommentMentionMetadata | undefined;

    return commentMentions?.version === 1 && Array.isArray(commentMentions.targets) ? commentMentions.targets : [];
};

const CommentMessage: FC<CommentMessageProps> = ({ message, metadata, popupZIndex }) => {
    const targetsByKey = new Map(mentionTargets(metadata).map((target) => [target.key, target]));
    const content: ReactNode[] = [];
    let cursor = 0;

    for (const match of message.matchAll(mentionMarkerPattern)) {
        const index = match.index ?? 0;
        const target = targetsByKey.get(match[2]);

        if (index > cursor) {
            content.push(message.slice(cursor, index));
        }
        content.push(
            target ? (
                <CommentMentionTag key={`${match[2]}:${index}`} mention={target} popupZIndex={popupZIndex} />
            ) : (
                `@${match[1]}`
            ),
        );
        cursor = index + match[0].length;
    }

    if (cursor < message.length) {
        content.push(message.slice(cursor));
    }

    return <span style={{ whiteSpace: 'pre-wrap' }}>{content}</span>;
};

export default CommentMessage;
